import { render, staticRenderFns } from "./FederalView.vue?vue&type=template&id=51653a12"
import script from "./FederalView.vue?vue&type=script&lang=js"
export * from "./FederalView.vue?vue&type=script&lang=js"
import style0 from "../css/app.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports